module.exports = __webpack_public_path__ + "media/images/case-studies/mt-alexander-c17b0a740f274caf1f5e8fbec972d55c.png";